import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
const HomePage = lazy(() => import('./pages/HomePage_Optimized'));
const ResultsPage = lazy(() => import('./pages/ResultsPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
import Loader from './components/Loader.jsx';
import PerformanceMonitor from './components/PerformanceMonitor.jsx';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-gray-100">
        {/* Performance monitoring in development */}
        {import.meta.env.DEV && <PerformanceMonitor />}
        
        {/* Skip to main content link for accessibility */}
        <a href="#main-content" className="sr-only focus:not-sr-only fixed top-2 left-2 z-50 bg-white dark:bg-gray-800 text-primary px-4 py-2 rounded shadow-lg">Hoppa till huvudinnehåll</a>
        <main id="main-content" className="flex-grow" tabIndex="-1">
          <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/results.html" element={<ResultsPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Suspense>
        </main>
      </div>
    </Router>
  );
}

export default App;
